<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1.94442 15.0279L14.2109 8.89471C14.9479 8.52618 14.9479 7.47438 14.2109 7.10585L1.94442 0.97262C1.18027 0.590542 0.319855 1.28074 0.527065 2.10958L1.81223 7.25024L6 7.25024C6.41421 7.25024 6.75 7.58603 6.75 8.00024C6.75 8.41446 6.41421 8.75024 6 8.75024L1.81225 8.75024L0.527065 13.891C0.319853 14.7198 1.18026 15.41 1.94442 15.0279Z"
  />
</template>
